var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6711 19.7115C20.1359 19.2498 20.8811 19.2498 21.3459 19.7115L24.4182 22.1915H24.4715C25.0931 22.8197 25.0931 23.8383 24.4715 24.4666C23.85 25.0948 22.8422 25.0948 22.2207 24.4666L19.6711 21.5445L19.5743 21.4354C19.3941 21.2072 19.2946 20.9228 19.2946 20.628C19.2946 20.2841 19.43 19.9543 19.6711 19.7115ZM11.2009 0.885254C13.9368 0.885254 16.5606 1.98378 18.4952 3.93916C20.4298 5.89454 21.5166 8.54661 21.5166 11.3119C21.5166 17.0704 16.8981 21.7386 11.2009 21.7386C5.50369 21.7386 0.885193 17.0704 0.885193 11.3119C0.885193 5.55344 5.50369 0.885254 11.2009 0.885254Z",
    fill: "#2F4858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/Search-Icon.12544255866295805397248740e014a1.svg";
export { ForwardRef as ReactComponent };